import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <span className="footer-logo">Garage <span>Eagle Car's</span></span>
            <p>Achat, vente, mécanique, carrosserie et dépannage 7j/7. Votre garage de confiance, toutes marques.</p>
          </div>

          <div className="footer-col">
            <h4>Navigation</h4>
            <Link to="/">Accueil</Link>
            <Link to="/voitures">Voitures</Link>
            <Link to="/contact">Contact</Link>
          </div>

          <div className="footer-col">
            <h4>Contact</h4>
            <p>40 Route de la Libération<br />74100 Étrembières</p>
            <a href="tel:+33676796771">06 76 79 67 71</a>
            <a href="tel:+33450795733">04 50 79 57 33</a>
            <a href="mailto:garage.eagle.cars@gmail.com">garage.eagle.cars@gmail.com</a>
          </div>
        </div>

        <div className="footer-bottom">
          <p>© {new Date().getFullYear()} Garage Eagle Car's · Tous droits réservés · <Link to="/mentions-legales">Mentions légales</Link></p>
          <p className="footer-credit">Site créé par <a href="https://www.linkedin.com/in/fjolla-qerimi-67082b333/" target="_blank" rel="noopener noreferrer">Fjolla Qerimi <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="currentColor" style={{verticalAlign:'middle', marginLeft:'4px'}}><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg></a></p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
